import { useId, type InputHTMLAttributes, type ReactNode, type Ref } from 'react';

export interface CaixaSelecaoProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  rotulo: ReactNode;
  descricao?: string;
  ref?: Ref<HTMLInputElement>;
}

/** Caixa de marcação com área de clique grande (rótulo inteiro é clicável). */
export function CaixaSelecao({ rotulo, descricao, id, ...props }: CaixaSelecaoProps) {
  const idGerado = useId();
  const idCampo = id ?? idGerado;
  return (
    <div className="flex items-start gap-3">
      <input
        id={idCampo}
        type="checkbox"
        aria-describedby={descricao ? `${idCampo}-descricao` : undefined}
        className="mt-0.5 size-5 shrink-0 accent-primaria"
        {...props}
      />
      <div className="flex flex-col">
        <label htmlFor={idCampo} className="text-sm font-medium text-texto">
          {rotulo}
        </label>
        {descricao && (
          <p id={`${idCampo}-descricao`} className="text-sm text-texto-suave">
            {descricao}
          </p>
        )}
      </div>
    </div>
  );
}
